import React from 'react';
import {
  ComposedChart, XAxis, YAxis, Legend,
  ResponsiveContainer, Bar, Line, Tooltip,
} from 'recharts';


const colors = {
  'APAC': 'rgba(120,181,255,0.7)',
  'EMEA': 'rgba(225,243,255,0.8)',
  'NA': 'rgba(51,225,255,0.6)',
};

const strokes = {
  'APAC': '#78B5FF',
  'EMEA': '#E1F3FF',
  'NA': '#33E1FF',
}

const altColors = [
  '#003f5c',
  '#7c0a02',
  '#00818a',
  '#e25822',
  '#5d1451',
  '#2f416d',
  '#1838d9',
  '#6003b3',
  '#d37f52',
  '#c05ad6',
];

const getPath = (x, y, width, height) => `M ${x} ${y + height}
          L ${x} ${y + width / 2}
          C ${x} ${y + width / 2} ${x} ${y} ${x + width / 2} ${y}
          C ${x + width} ${y} ${x + width} ${y + width / 2} ${x + width} ${y + width / 2}
          L ${x + width} ${y + height}
          Z`;

const TriangleBar = (props) => {
  const {
    stroke, fill, x, y, width, height,
  } = props;

  return <path d={height + y > y + width / 2 ? getPath(x, y, width, height) : null} stroke={stroke} fill={fill} />;
};

class RegionalComparison extends React.Component {
customTick = (e) => {
  return (
    <g>
    <text
      fill="#ccc"
      x={e.x}
      y={e.y}
      radius={e.radius}
      className="recharts-text recharts-polar-radius-axis-tick-value"
      textAnchor={e.textAnchor}>
      <tspan x={e.x} dy="0em">{e.payload.value}</tspan>
    </text>
    </g>
  );
}

generateDataSet = (data) => {
  const overAll = {
    name: 'Overall',
  };
  const policy = {
    name: 'Policy',
  };
  const practice = {
    name: 'Practice',
  };
  const platform = {
    name: 'Platform',
  };
  const { crossIndustry, sameIndustry } = this.props;
  let policyBuffer = {};
  let practiceBuffer = {};
  let platformBuffer = {};
  let overAllBuffer = {};

  function getAvg(arr) {
    let sum = 0;
    for (let i = 0, length = arr.length; i < length; i += 1) {
      sum += arr[i];
    }
    return (sum / arr.length).toFixed(2);
  }
  for (let i = 0, length = data['policy'].length; i < length; i += 1) {
    if (policyBuffer[data['policy'][i]['label']]) {
      policyBuffer[data['policy'][i]['label']].push(data['policy'][i]['value']);
    } else {
      policyBuffer[data['policy'][i]['label']] = [data['policy'][i]['value']];
    }
    if (overAllBuffer[data['policy'][i]['label']]) {
      overAllBuffer[data['policy'][i]['label']].push(data['policy'][i]['value']);
    } else {
      overAllBuffer[data['policy'][i]['label']] = [data['policy'][i]['value']];
    }
  }
  for (let key in policyBuffer) {
    policy[key] = getAvg(policyBuffer[key])
  }
  for (let i = 0, length = data['practice'].length; i < length; i += 1) {
    if (practiceBuffer[data['practice'][i]['label']]) {
      practiceBuffer[data['practice'][i]['label']].push(data['practice'][i]['value']);
    } else {
      practiceBuffer[data['practice'][i]['label']] = [data['practice'][i]['value']];
    }
    if (overAllBuffer[data['practice'][i]['label']]) {
      overAllBuffer[data['practice'][i]['label']].push(data['practice'][i]['value']);
    } else {
      overAllBuffer[data['practice'][i]['label']] = [data['practice'][i]['value']];
    }
  }
  for (let key in practiceBuffer) {
    practice[key] = getAvg(practiceBuffer[key])
  }
  for (let i = 0, length = data['platform'].length; i < length; i += 1) {
    if (platformBuffer[data['platform'][i]['label']]) {
      platformBuffer[data['platform'][i]['label']].push(data['platform'][i]['value']);
    } else {
      platformBuffer[data['platform'][i]['label']] = [data['platform'][i]['value']];
    }
    if (overAllBuffer[data['platform'][i]['label']]) {
      overAllBuffer[data['platform'][i]['label']].push(data['platform'][i]['value']);
    } else {
      overAllBuffer[data['platform'][i]['label']] = [data['platform'][i]['value']];
    }
  }
  for (let key in platformBuffer) {
    platform[key] = getAvg(platformBuffer[key])
  }
  for (let key in overAllBuffer) {
    overAll[key] = getAvg(overAllBuffer[key])
  }

  if (sameIndustry && sameIndustry['policy']) {
    policy['sameIndustry'] = sameIndustry['policy'];
    practice['sameIndustry'] = sameIndustry['practice'];
    platform['sameIndustry'] = sameIndustry['platform'];
    overAll['sameIndustry'] = ((sameIndustry['policy'] + sameIndustry['practice'] + sameIndustry['platform']) / 3).toFixed(2);
  }
  if (crossIndustry && crossIndustry['policy']) {
    policy['crossIndustry'] = crossIndustry['policy'];
    practice['crossIndustry'] = crossIndustry['practice'];
    platform['crossIndustry'] = crossIndustry['platform'];
    overAll['crossIndustry'] = ((crossIndustry['policy'] + crossIndustry['practice'] + crossIndustry['platform']) / 3).toFixed(2);
  }
  return [overAll, policy, practice, platform];
}

customCategoryTick = (e) => {
  function getCategory(value) {
    if (value === 3.85) {
      return 'High\nPerforming';
    } else if (value === 3.5) {
      return 'Above\nAverage';
    } else if (value === 2.875) {
      return 'Enhanced';
    } else {
      return 'Base';
    }
  }
  return (
    <g>
    <foreignObject
      fill="#fff"
      x={e.x - 10}
      y={e.y - 10}
      width="75"
      height="45"
      className="recharts-category-text"
      textAnchor={e.textAnchor}
    >
      <p
        style={{
          fontSize: '0.6791rem',
          borderTop: '1px solid #FFF',
          borderBottom: '1px solid #FFF',
          backgroundColor: 'rgba(0,0,0,0.4)',
        }}
        className="mb-0 text-left"
        xmlns="http://www.w3.org/1999/xhtml"
      >
        {getCategory(e.payload.value)}
      </p>
    </foreignObject>
    </g>
  );
}

generateBars(data) {
  return(
    data.map((structure, index) => (
      <Bar
        key={index}
        dataKey={structure['label']}
        barSize={30}
        shape={<TriangleBar />}
        fill={colors[structure['label']] ? colors[structure['label']] : altColors[index]}
        stroke={strokes[structure['label']] ? strokes[structure['label']] : altColors[index]}
        legendType="circle"
        label={{
          position: 'top',
          fill: strokes[structure['label']] ? strokes[structure['label']] : altColors[index]
        }}
      />
    ))
  );
}

  render() {
    return (
      <div className="charts-container dot-charts-container bar-chart-container h-103 w-100 m-0 p-0">
        <div className="h-100 w-100">
          <ResponsiveContainer>
            <ComposedChart
              barGap='12'
              data={this.generateDataSet(this.props.data)}
              margin={{
                top: 20, right: 20, bottom: 20, left: 20,
              }}
            >
              <XAxis dataKey="name" stroke="#FFF" strokeWidth={2} />
              <YAxis
                domain={[1, 4]}
                ticks={[1, 1.375, 1.75, 2.125, 2.5, 2.875, 3.25, 3.625, 4]}
                interval={0}
                orientation="left"
              />
              <YAxis
                yAxisId="right"
                tickLine={false}
                orientation="right"
                interval={0}
                ticks={[1.75, 2.875, 3.5, 3.85]}
                domain={[1, 4]}
                tick={this.customCategoryTick}
              />
              <Tooltip
                contentStyle={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
              />
              <Legend />
              { this.generateBars(this.props.data['regions']) }
              { this.props.sameIndustry ?
                <Line
                  type="monotone"
                  dataKey="sameIndustry"
                  name="Same Industry"
                  stroke="#77FB89"
                  strokeWidth={4}
                  dot={{ stroke: '#77FB89', fill: '#FFF', strokeWidth: 4, r: 5 }}
                /> : null
              }
              { this.props.crossIndustry ?
                <Line
                  type="monotone"
                  dataKey="crossIndustry"
                  name="Cross Industry"
                  stroke="#F3CA3E"
                  strokeWidth={4}
                  dot={{ stroke: '#F3CA3E', fill: '#FFF', strokeWidth: 4, r: 5 }}
                /> : null
              }
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default RegionalComparison;
